import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface BanTeamMemberModalInput {
  userName: string;
  teamName: string;
}

@Component({
  selector: 'ban-team-member-modal',
  templateUrl: 'ban-team-member-modal.component.pug',
})
export class BanTeamMemberModalComponent {
  @Output() close = new EventEmitter<boolean | undefined>();
  @Input() data!: BanTeamMemberModalInput;

  onBan() {
    this.close.emit(true);
  }

  onClose() {
    this.close.emit(undefined);
  }
}
